import {
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Row,
  UncontrolledAlert,
} from "reactstrap";
import React from "react";

export const AccountAlert: React.FC = () => {
  return (
    <Row>
      <Card>
        <CardHeader>{/*<CardTitle tag="h4">Info:</CardTitle>*/}</CardHeader>
        <CardBody>
          <UncontrolledAlert color="danger">
            <span>
              <b>Danger - </b>
              This is account is not initialized! To initialize this account,
              send a self or outgoing transaction.
            </span>
          </UncontrolledAlert>
        </CardBody>
      </Card>
    </Row>
  );
};
